<template>
  <v-dialog v-model="show">
    <v-card>
      <v-container fluid class="fill-height">
        <v-toolbar-title> {{ toolBarTitle }} </v-toolbar-title>
        <v-row justify="space-around">
          <v-col cols="5">
            <JsonEditor
              :options="{ confirmText: 'confirm', cancelText: 'cancel' }"
              :objData="crudData"
              v-model="crudData"
            >
            </JsonEditor>
          </v-col>

          <v-col cols="5">
            <div v-if="showErrors" class="d-flex justify-space-between">
              <p class="font-weight-regular red--text text--lighten-1 ml-2'">
                {{ this.errorMessage }}
              </p>
              <v-spacer></v-spacer>
              <span v-show="status">
                <v-icon v-show="status" right> mdi-set-none </v-icon>
                Status:
              </span>
              <span
                v-show="status"
                v-bind:class="{
                  'green--text text--lighten-1 ml-2': status === 200,
                  'red--text text--lighten-1 ml-2': status !== 200
                }"
              >
                {{ status }}
              </span>
            </div>

            <ace-editor
              :content="JSON.stringify(this.crudData, undefined, 4)"
              xml:lang="json"
              :on-change="aceEditorOnChange"
            />
            <v-btn color="primary" dark class="mb-2" text @click="handleAction"
              >{{ this.action === 'edit' ? 'Update' : 'Create' }}
              {{ referential.elementName }}</v-btn
            >
            <v-btn color="primary" dark class="mb-2" text @click="close"
              >Cancel</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import AceEditor from '@/components/AceEditor';
import VueVuelidateJsonschema from 'vue-vuelidate-jsonschema';
import errorsMapping from '../errorsMapping.json';

const { mapActions, mapState } = createNamespacedHelpers('referentials');
const { mapState: mapStateConfig } = createNamespacedHelpers('config');
export default {
  name: 'CustomJsonEditor',
  components: { AceEditor },
  mixins: [VueVuelidateJsonschema.mixin],
  validations: {},
  data() {
    return {
      crudData: {},
      referentialCode: '',
      errorMessage: '',
      showErrors: false
    };
  },
  watch: {
    data() {
      this.crudData = this.prepareCrudData(this.data);
      this.referentialCode = this.data.code;
    }
  },
  props: {
    referential: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    value: Boolean
  },
  computed: {
    ...mapState(['responseData', 'status']),
    ...mapStateConfig(['currentDivision']),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    toolBarTitle: function() {
      let divisionName = '';
      if (this.currentDivision === '3DIV') {
        divisionName = 'pearl';
      } else {
        divisionName = this.currentDivision.toLowerCase();
      }
      if (this.action === 'create') {
        return `Create new ${divisionName} ${this.referential.elementName.toLowerCase()}`;
      } else {
        return `Update existing ${divisionName} ${this.referential.elementName.toLowerCase()}`;
      }
    }
  },
  methods: {
    ...mapActions([
      'createReferential',
      'updateReferential',
      'getReferentialData',
      'getFullReferentialData'
    ]),
    close() {
      this.show = false;
      this.showErrors = false;
    },
    prepareCrudData(crudData) {
      if ('links' in crudData) {
        delete crudData.links;
      }
      if ('pearlData' in crudData) {
        delete crudData.pearlData;
      }
      return crudData;
    },
    aceEditorOnChange(val) {
      if (this.isValidJSONString(val)) {
        this.crudData = JSON.parse(val);
      }
    },
    isValidJSONString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    async handleAction() {
      let params;
      if (this.action === 'edit') {
        params = {
          referentialUri: this.referential.url,
          referentialCode: this.referentialCode,
          referentialData: this.crudData
        };
        await this.updateReferential(params);
      } else {
        params = {
          referentialUri: this.referential.url,
          referentialData: this.crudData
        };
        await this.createReferential(params);
      }
      this.checkStatus();
    },
    async checkStatus() {
      if (this.status === 200) {
        await this.getReferentialData(this.referential);
        this.close();
        await this.getFullReferentialData(this.referential);
        this.errorMessage = '';
      } else {
        let error = errorsMapping.filter(
          error => error.code === this.status
        )[0];
        this.errorMessage = `${this.referential.elementName} ${error.message}`;
        this.showErrors = true;
      }
    }
  }
};
</script>
